module.exports = "data:image/webp;base64,UklGRl4BAABXRUJQVlA4IFIBAADQBgCdASoZABkAPpE8mEiloyIhKA1QsBIJZgCdMoR4yEBM3bQHR3Z8xXLFOcQF6PKUMAUvmAbDA91/csiC4EAA/vcRTekJLbHsVgrsY3NtR4qHbCbHQHeqyrE9nERVqVQ0vYOUikPqZ7s7OrPtJ9g3tBUnLRGiS69W8lnyws066uqAWjUKKxH8RwflT9uEL9Ax2hI3+s5pK1+cti+3Dx501eWk425NqvnJvFe0mIMDU6vJ8778uhGo43ozkue6FLEbp+hWqbtpQ9X/wEx6Oq57k+7QCqnZ+eQfsC3X4la7CYBKzPx0rPzGfqg5ylr364mt9PqQUgMrPsIqGL8GXb/vUf16/s52/nCO3sYiBaTGJ4LdhAPu3s+Y3oB33UATIRAY/ZYfYdw6+I+3D2OH5gMAGoAWZf4Xw4Dn3wkg2zEQc1o3SKZ4/Vujccml9lIv9yAAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/blue_floral.webp
// module id = QNjq
// module chunks = 14